import React from 'react';
import '../App.css';
import './ClinicalSupervision.css'
import { motion } from 'framer-motion';
import Header from './CSFAQHeader.png'
import ReactCardFlip from 'react-card-flip';

class CSFAQ extends React.Component {

    constructor() {
        super();
        this.state = {
            q1: false,
            q2: false,
            q3: false,
            q4: false,
            q5: false,
            q6: false,
            q7: false,
        };
        this.q1Flip = this.q1Flip.bind(this);
        this.q2Flip = this.q2Flip.bind(this);
        this.q3Flip = this.q3Flip.bind(this);
        this.q4Flip = this.q4Flip.bind(this);
        this.q5Flip = this.q5Flip.bind(this);
        this.q6Flip = this.q6Flip.bind(this);
        this.q7Flip = this.q7Flip.bind(this);
    }

    q1Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q1: !prevState.q1 }));
    }

    q2Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q2: !prevState.q2 }));
    }

    q3Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q3: !prevState.q3 }));
    }

    q4Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q4: !prevState.q4 }));
    }

    q5Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q5: !prevState.q5 }));
    }

    q6Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q6: !prevState.q6 }));
    }

    q7Flip(e) {
        e.preventDefault();
        this.setState(prevState => ({ q7: !prevState.q7 }));
    }

    render() {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q1} flipDirection="vertical">
                        <button onClick={this.q1Flip} className="faq-card">
                            <div className="faq-question">
                                What is clinical supervision?
                            </div>
                        </button>

                        <button onClick={this.q1Flip} className="faq-card2">
                            <div className="faq-answer">
                                Clinical supervision is a collaborative relationship that supports the development of safe, ethical, and effective psychotherapy practice. Through ongoing dialogue, Tracy provide feedback, guidance, and skill development while monitoring clinical competency.
                                <br /><br />
                                This process prioritizes client safety, supports professional growth, and enhances self-awareness. Supervision also creates space to reflect on the emotional experience of clinical work, helping supervisees build confidence and strengthen their therapeutic approach.
                            </div>
                        </button>
                    </ReactCardFlip>
                </div>
                <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q2} flipDirection="vertical">
                        <button onClick={this.q2Flip} className="faq-card">
                            <div className="faq-question">
                                What if I have an urgent issue?
                            </div>
                        </button>

                        <button onClick={this.q2Flip} className="faq-card2">
                            <div className="faq-answer">
                                Tracy understands that challenging clinical situations can leave you feeling uncertain—especially when navigating new experiences in psychotherapy practice. That’s why Tracy prioritizes strong clinical supervision, ongoing support, and collaborative consultation. During your initial supervision session with Tracy, you will discuss how to navigate urgent situations (e.g., how to reach Tracy after hours for emergencies).
                            </div>
                        </button>
                    </ReactCardFlip>
                </div>
                <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q3} flipDirection="vertical">
                        <button onClick={this.q3Flip} className="faq-card">
                            <div className="faq-question">
                                How many supervision hours do I need?
                            </div>
                        </button>

                        <button onClick={this.q3Flip} className="faq-card2">
                            <div className="faq-answer">
                                The number of clinical supervision hours you need depends on College of Registered Psychotherapists of Ontario requirements and your stage of professional development. For example, Registered Psychotherapist (Qualifying) members require a set number of supervision hours to become fully registered, and additional hours are needed for independent practice.
                                <br /><br />
                                All supervisees are encouraged to review CRPO supervision requirements directly to determine the appropriate frequency and number of hours. Tracy does not provide official guidance on required hours, but she is happy to support you in identifying your supervision needs and professional goals.
                            </div>
                        </button>
                    </ReactCardFlip>
                </div>
                <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q4} flipDirection="vertical">
                        <button onClick={this.q4Flip} className="faq-card">
                            <div className="faq-question">
                                Who is clinical supervision for?
                            </div>
                        </button>

                        <button onClick={this.q4Flip} className="faq-card2">
                            <div className="faq-answer">
                                Clinical supervision is for Registered Psychotherapists (Qualifying), Registered Psychotherapists, and social workers seeking to develop their clinical skills, meet CRPO requirements, or receive ongoing professional support.
                            </div>
                        </button>
                    </ReactCardFlip>
                </div>
                <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q5} flipDirection="vertical">
                        <button onClick={this.q5Flip} className="faq-card">
                            <div className="faq-question">
                                Do you offer virtual clinical supervision in Ontario?
                            </div>
                        </button>

                        <button onClick={this.q5Flip} className="faq-card2">
                            <div className="faq-answer">
                                Yes, supervision is offered virtually across Ontario, making it accessible and flexible for busy clinicians.                            </div>
                        </button>
                    </ReactCardFlip>
                </div>
                <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q6} flipDirection="vertical">
                        <button onClick={this.q6Flip} className="faq-card">
                            <div className="faq-question">
                                Can I receive supervision if I’m already in independent practice?
                            </div>
                        </button>

                        <button onClick={this.q6Flip} className="faq-card2">
                            <div className="faq-answer">
                                Yes, supervision is valuable at all stages of practice, including independent practitioners seeking consultation, support, or continued professional development.                           </div>
                        </button>
                    </ReactCardFlip>
                </div>
                <div className="faq-container">
                    <ReactCardFlip isFlipped={this.state.q7} flipDirection="vertical">
                        <button onClick={this.q7Flip} className="faq-card">
                            <div className="faq-question">
                                How do I get started with supervision?
                            </div>
                        </button>

                        <button onClick={this.q7Flip} className="faq-card2">
                            <div className="faq-answer">
                                You can reach out to book a consultation to discuss your goals, supervision needs, and fit. Call or text 647-547-2566 or email supervision@talltreepsychotherapy.ca
                            </div>
                        </button>
                    </ReactCardFlip>
                </div>
            </motion.div>
        )
    }
}

export default CSFAQ;